export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

/** База API бэкенда и сборка URL — единый модуль `shared/config/apiBase`. */
export { API_BASE_URL, apiUrl } from '../../shared/config/apiBase';
